import { Component, EventEmitter, HostBinding, HostListener, Input, Output, ViewChild, ElementRef } from "@angular/core";

@Component({
    selector: "sps-datepicker-input",
    templateUrl: "./sps-datepicker-input.component.html",
})
export class SpsDatepickerInputComponent {
    @HostBinding("class.sps-datepicker__input") readonly _spsDatepickerInputsClass = true;
    @HostBinding("attr.tabindex") readonly _tabindex = -1;

    @Input() disabled: boolean;
    @Input() clearable: boolean;
    @Input() placeholder: string;
    @Input() presetText: string;
    @Input() ariaLabel: string;
    @Input() inputId: string;

    @Input() text: string;
    @Output() textChange = new EventEmitter<string>();

    @Output() activated = new EventEmitter<void>();
    @Output() clear = new EventEmitter<void>();

    @ViewChild("textInput", { static: false }) textInput: ElementRef;

    @HostListener("focus") onFocus() {
        this.textInput.nativeElement.focus();
    }

    onTextInputChange(event) {
        this.textChange.emit(event.target.value);
    }
}
